import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType } from 'vue'
import { ElementTypes, PPTElement } from '@/types/slides'

import ImageElement from '@/views/components/element/ImageElement/index.vue'
import TextElement from '@/views/components/element/TextElement/index.vue'
import ShapeElement from '@/views/components/element/ShapeElement/index.vue'
import LineElement from '@/views/components/element/LineElement/index.vue'
import ChartElement from '@/views/components/element/ChartElement/index.vue'
import TableElement from '@/views/components/element/TableElement/index.vue'
import LatexElement from '@/views/components/element/LatexElement/index.vue'
import VideoElement from '@/views/components/element/VideoElement/index.vue'
import AudioElement from '@/views/components/element/AudioElement/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileEditableElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTElement>,
    required: true,
  },
  elementIndex: {
    type: Number,
    required: true,
  },
  selectElement: {
    type: Function as PropType<(e: TouchEvent, element: PPTElement, canMove?: boolean) => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const currentElementComponent = computed(() => {
  const elementTypeMap = {
    [ElementTypes.IMAGE]: ImageElement,
    [ElementTypes.TEXT]: TextElement,
    [ElementTypes.SHAPE]: ShapeElement,
    [ElementTypes.LINE]: LineElement,
    [ElementTypes.CHART]: ChartElement,
    [ElementTypes.TABLE]: TableElement,
    [ElementTypes.LATEX]: LatexElement,
    [ElementTypes.VIDEO]: VideoElement,
    [ElementTypes.AUDIO]: AudioElement,
  }
  return elementTypeMap[props.elementInfo.type] || null
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "mobile-editable-element",
    style: _normalizeStyle({
      zIndex: __props.elementIndex,
    })
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentElementComponent)), {
      elementInfo: __props.elementInfo,
      selectElement: __props.selectElement,
      contextmenus: () => null
    }, null, 8, ["elementInfo", "selectElement", "contextmenus"]))
  ], 4))
}
}

})